module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.f6d94276.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Regular/Rubik-Regular.eot
// module id = 1296
// module chunks = 49